<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
            v-model="form"
    >
        <template slot="menuLeft">
            <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('公务车申请', '用户、工号、部门、电话、车辆信息、用车日期、用车时间、用车原因、申请状态')">导出Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
            <el-button icon="el-icon-edit" size="small" type="text" v-if="scope.row.status===0" @click.stop="handleReply(scope.row,scope.index)">审核</el-button>
        </template>
        <template slot-scope="scope" slot="status">
            <span v-if="scope.row.status===0">待审核</span>
            <span v-if="scope.row.status===1" style="color: green">审核通过</span>
            <span v-if="scope.row.status===2" style="color: crimson">审核不通过</span>
        </template>
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        form:{
          status:0,
        },
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText:'新增活动', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText:'审核', // 新增按钮文案
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '用户信息',
              editDisplay: false,
              prop: 'user-username'
            }, {
              label: '工号',
              prop: 'user_id',
              span: 24,
              editDisplay: false
            }, {
              label: '部门',
              prop: 'user-class',
              span: 24,
              editDisplay: false
            }, {
              label: '电话',
              prop: 'user-tel',
              span: 24,
              editDisplay: false
            }, {
              label: '用车日期',
              prop: 'date',
              editDisplay: false
            }, {
              label: '用车时间',
              prop: 'time',
              editDisplay: false
            }, {
              label: '用车原因',
              prop: 'reason',
              overHidden: true,
              editDisplay: false
            }, {
              label: '申请状态',
              prop: 'status',
              span: 24,
              type: 'select',
              slot: true,
              search: true,
              dicUrl: this.getDic('affair.car_status'),
            }, {
              label: '车辆信息',
              prop: 'car_id',
              span: 24,
              type: 'select',
              display: false,
              props: {
                label: 'no',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/affair/car'
            }, {
              label: '出发地',
              prop: 'start_place',
              editDisplay: false,
              overHidden: true,
              hide: true,
              span: 24
            }, {
              label: '目的地',
              prop: 'end_place',
              editDisplay: false,
              overHidden: true,
              hide: true,
              span: 24
            }, {
              label: '乘坐人员',
              prop: 'person',
              editDisplay: false,
              overHidden: true,
              hide: true,
              span: 24
            }, {
              label: '审核时间',
              prop: 'examine_time',
              hide: true,
              editDisplay: false
            }, {
              label: '审核备注',
              prop: 'note',
              span: 24,
              hide: true
            }
          ]
        }
      }
    },
    methods: {
      // 审核
      handleReply (row, index) {
        this.$refs.crud.rowEdit(row, index)
      }
    },
    watch: {
      'form.status': {
        handler(val) {
          var car_id = this.findObject(this.option.column, 'car_id');
          if (val === 1) { // 公开
            car_id.display = true;
            car_id.rules = [{
              required: true,
              message: "请选择车辆信息",
              trigger: "blur"
            }]
          } else {
            car_id.display = false;
            car_id.rules = []
          }
        },
        immediate: true
      }
    }
  }
</script>
